import { BuffList } from './BuffList';
import { PlayerVitals } from './PlayerVitals';
import { SpellBar } from './SpellBar';
import './PlayerCluster.scss';

export const PlayerCluster = () => {
  return (
    <div className="player-cluster">
      <BuffList />
      <div className="player-panel">
        <PlayerVitals />
        <SpellBar />
      </div>
    </div>
  );
};
